import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';

import configureStore from './configureStore';
import { AGPSettingsContextProvider } from './dashboard/AGPSettingsContext';
import { NotificationsContextProvider } from './NotificationsContext';
import { NutritionSettingContextProvider } from './dashboard/NutritionSettingsContext';
import { PresentationContextProvider } from './PresentationContext';
import { TargetContextProvider } from './dashboard/TargetContext';
import { initialState as initialData } from './reducers/data';
import { DayFilterContextProvider } from './DayFilterContext';
import { InsulinSettingContextProvider } from './dashboard/InsulinSettingsContext';

export const defaultStore = Object.freeze({
  data: initialData,
  session: {},
});

const reduxStore = configureStore(defaultStore);

export function Contexts({ children }) {
  return (
    <PresentationContextProvider>
      <ReduxProvider store={reduxStore}>
        <DayFilterContextProvider>
          <NotificationsContextProvider>
            <TargetContextProvider>
              <AGPSettingsContextProvider>
                <NutritionSettingContextProvider>
                  <InsulinSettingContextProvider>
                    {children}
                  </InsulinSettingContextProvider>
                </NutritionSettingContextProvider>
              </AGPSettingsContextProvider>
            </TargetContextProvider>
          </NotificationsContextProvider>
        </DayFilterContextProvider>
      </ReduxProvider>
    </PresentationContextProvider>
  );
}

export default Contexts;
